'use client';

import dynamic from 'next/dynamic';

const PhotoMapClient = dynamic(() => import('./map-client'), { ssr: false });

export default function MapWrapper({ eventId }: { eventId: string }) {
  return <PhotoMapClient eventId={eventId} />;
}
